export function getSessionToken() {
  return localStorage.getItem("eaveToken");
}

export function saveSessionToken(authToken) {
  localStorage.setItem("eaveToken", authToken);
}

export function getEaveImpersonator() {
  const stringified = localStorage.getItem("eaveImpersonator");
  if (stringified) {
    return JSON.parse(stringified);
  }
}

export function setEaveImpersonator(user) {
  localStorage.setItem("eaveImpersonator", user);
}

export function saveFileDownloadToken(fileAuthToken) {
  document.cookie = `EaveFileAuthorization=${fileAuthToken}; path=/files/`;
}

export const endSession = () => {
  localStorage.removeItem("eaveToken");
  localStorage.removeItem("eaveImpersonator");

  // to delete a cookie, set its expiration in the past
  // cookie params must match exactly the create params (path, domain, etc)
  const yesterday = new Date();
  yesterday.setTime(yesterday.getTime() + -1 * 24 * 60 * 60 * 1000);
  document.cookie = `EaveFileAuthorization=; path=/files/; expires=${yesterday.toUTCString()}`;
};
